import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logError } from '../../../shared/logError';
import { NOTIFICATIONS_DRAWER_LOG_MODULE } from '../../../RealtimeNotifications/shared/constants';

export async function setSoundEnabled(isEnabled) {
    const url = pathfinder('settings_desktop_audio');
    try {
        await axios.post(url, { value: isEnabled.toString() });
    } catch (err) {
        logError(err, { module: NOTIFICATIONS_DRAWER_LOG_MODULE, payload: { fn: 'setSoundEnabled' } });
    }
}
